import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  ChartData,
  ChartOptions,
  Filler,
  LinearScale,
  LineElement,
  PointElement,
  ScriptableContext,
  Title,
  Tooltip,
} from 'chart.js'
import { FC, ReactElement, useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2'
import {
  Container,
  ContainerCard,
  Header,
  LineContainer,
  TitleChart,
  TitleChartContainer,
  TitleContainerMobile,
  TitleTextMobile,
} from './styles'
import { DefaultCardDashboard } from 'bd-web-components'
import { useGetDailyConversion } from '../../../hooks/daily-convertion'
import Loader from '../../../components/Loader'

Chart.register(
  BarController,
  CategoryScale,
  Filler,
  LinearScale,
  BarElement,
  Tooltip,
  Title,
  PointElement,
  LineElement
)

const cardChartOptions: ChartOptions<'line'> = {
  maintainAspectRatio: false,
  responsive: true,
  aspectRatio: 1,

  scales: {
    y: {
      beginAtZero: true,
    },
    x: {
      grid: {
        display: false, // Desativa a exibição das linhas do eixo x
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },

  elements: {
    point: {
      borderColor: 'red', // Defina a cor desejada para a borda dos pontos
      borderWidth: 2, // Defina a largura da borda dos pontos
      radius: 6, // Defina o raio dos pontos
      backgroundColor: 'white', // Defina a cor desejada para o preenchimento do background dos pontos
    },
    line: {
      borderColor: 'black', // defina a cor desejada para a linha do grafico,
      borderWidth: 2,
      fill: true,
      backgroundColor: (context: ScriptableContext<'line'>) => {
        const ctx = context.chart.ctx
        const gradient = ctx.createLinearGradient(0, 0, 0, 350)
        gradient.addColorStop(0, '#121926')
        gradient.addColorStop(1, 'transparent')
        return gradient
      },
    },
  },
}

interface DataObject {
  dia: string
  receita: number
  sector?: number
  quantidadeIngressosVendidos: number
}

interface ChartDataProps {
  labels: string[]
  data: string[]
}

export interface SalesChartProps {
  chartData?: ChartData<
    'line',
    Array<number | [number, number] | number>,
    unknown
  >
  label?: string
}

const SalesChart: FC<SalesChartProps> = ({
  label,
}: SalesChartProps): ReactElement => {
  const [sales, setSales] = useState<any>([
    {
      dia: '2001-01-01',
      quantidadeIngressosVendidos: '0',
    },
  ])

  const { dailyConversion, dailyConversionLoading, dailyConversionError } =
    useGetDailyConversion(true)

  useEffect(() => {
    if (dailyConversion !== undefined) {
      setSales(dailyConversion)
    }
  }, [dailyConversion, dailyConversionLoading, dailyConversionError])

  function formatData(dataString: string = ''): string {
    const dia = dataString.slice(8, 10)
    const mes = dataString.slice(5, 7)
    return `${dia}/${mes}`
  }

  const modelData = (data: DataObject[]): ChartDataProps => {
    const model: ChartDataProps = {
      labels: [],
      data: [],
    }
    data.forEach((sale: DataObject): void => {
      if (sale.dia !== undefined) {
        model.labels.push(formatData(sale.dia))
        model.data.push(sale.quantidadeIngressosVendidos.toString())
      }
    })
    return model
  }

  const renderData = modelData(sales)

  return (
    <Container>
      <TitleContainerMobile>
        <TitleTextMobile>Conversão diária</TitleTextMobile>
      </TitleContainerMobile>
      <ContainerCard>
        <DefaultCardDashboard>
          {sales[0].dia !== '2001-01-01' && (
            <>
              <Header>
                <TitleChartContainer>
                  <TitleChart>Conversão diária (%) </TitleChart>
                </TitleChartContainer>
              </Header>
              <LineContainer>
                <Line
                  data={{
                    labels: renderData.labels ?? [],
                    datasets: [{ label: label ?? '', data: renderData.data }],
                  }}
                  options={cardChartOptions}
                />
              </LineContainer>
            </>
          )}
          {dailyConversionLoading && (
            <div
              style={{
                height: '600px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Loader />
            </div>
          )}
        </DefaultCardDashboard>
      </ContainerCard>
    </Container>
  )
}

export default SalesChart
